import { render, staticRenderFns } from "./HospitalIntroChongai.vue?vue&type=template&id=8f0e697e&scoped=true"
import script from "./HospitalIntroChongai.vue?vue&type=script&lang=js"
export * from "./HospitalIntroChongai.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroChongai.vue?vue&type=style&index=0&id=8f0e697e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0e697e",
  null
  
)

export default component.exports